<template>
<article class="org-inner">
  <ElTabs>
    <ElTabPane :label="$t('账号')"> <accountCom></accountCom> </ElTabPane>
  </ElTabs>
</article>
</template>

<script setup="true" name="Account">
import accountCom from '../organization/newAccount/index.vue'
</script>

<style lang="scss" scoped>
.org-inner {
  padding: 16px;
  background: #fff;
  :deep(.el-tabs__header) {
    margin-bottom: 0 !important;
  }
  :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: #EFF4FF;
  }
  :deep(.el-tabs__active-bar) {
    background-color: #4A7CF6;
  }
  :deep(.el-tabs__item) {
    font-weight: 400;
    font-size: 14px;
    color: #575B6B;
    &.is-active {
      font-weight: 500;
      color: #283145;
    }
  }
}
</style>
